import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  filterPaperWrapper: {
    width: 450,
    maxHeight: 410,
    overflow: 'auto',
  },
  paper: {
    zIndex: theme.zIndex.modal,
  },
  inputWidth: {
    maxWidth: 128,
  },
}));
